import { render, staticRenderFns } from "./ConfigurationRequestsView.vue?vue&type=template&id=7326cf56&scoped=true"
import script from "./ConfigurationRequestsView.vue?vue&type=script&lang=js"
export * from "./ConfigurationRequestsView.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationRequestsView.vue?vue&type=style&index=0&id=7326cf56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7326cf56",
  null
  
)

export default component.exports